/** Splits a single name input into first + last on the first space. */
export default function splitFullName(value: string): { firstName: string; lastName: string } {
  const trimmed = value.trim()
  const spaceIndex = trimmed.indexOf(' ')

  return {
    firstName: spaceIndex > 0 ? trimmed.substring(0, spaceIndex) : trimmed,
    lastName: spaceIndex > 0 ? trimmed.substring(spaceIndex + 1).trim() : '',
  }
}
